import { Privilege, UserData } from 'common/constants/types';
import { createAssetUrl } from './http';

const privilegeAttribute = (name: string): boolean =>
  name === 'admin_privileges' || name === 'privileges';

export const getPrivilegesFromUser = (loggedInUser: UserData): Privilege[] => (loggedInUser
  .genres.find(genre => genre.name === 'user-info')
  ?.sections.find(section => section.name === 'misc')
  ?.attribute_types.filter(attributeType => privilegeAttribute(attributeType.name))
  .flatMap(attributeType => attributeType.attributes)
  .map(attribute => attribute.value) || []) as Privilege[];

export const extractAvatarUrl = (loggedInUser: UserData): string | undefined => {
  const avatarAttribute = loggedInUser
    .genres.find(genre => genre.name === 'user-info')
    ?.sections.find(section => section.name === 'personal')
    ?.attribute_types.find(attributeType => attributeType.name === 'avatar')
    ?.attributes[0];
  if (avatarAttribute) {
    return createAssetUrl(avatarAttribute.id);
  }
  return undefined;
};

export default {
  getPrivilegesFromUser,
  extractAvatarUrl,
};
